import styled from 'styled-components';
import VizExIconButton from 'visitor-ui-component-library/button/VizExIconButton';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import SVGPlay from 'visitor-ui-component-library-icons/icons/SVGPlay';
import SVGPause from 'visitor-ui-component-library-icons/icons/SVGPause';
import VizExLoadingSpinner from 'visitor-ui-component-library/loading/VizExLoadingSpinner';
import I18n from 'I18n';
import { shouldShowPlayButton, handlePlayButtonClick } from './speechButtonUtils';
// @ts-expect-error - Missing declaration file for conversations-message-history module
import { getId } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
// @ts-expect-error - Missing declaration file for conversations-visitor-ui module
import { jsx as _jsx } from "react/jsx-runtime";
const PlayMessageButtonWrapper = styled.div.withConfig({
  displayName: "PlayMessageButton__PlayMessageButtonWrapper"
})(["position:absolute;bottom:0;right:0;transform:translate(33.3%,33.3%);z-index:10;"]);
const PlayMessageButton = ({
  message,
  positionDescriptors,
  speechPocActive = false,
  audioPlaybackStatus = 'paused',
  messagesList,
  size = 'sm'
}) => {
  const shouldShow = shouldShowPlayButton(message, positionDescriptors, messagesList, speechPocActive);
  if (!shouldShow) {
    return null;
  }
  const handleButtonClick = () => {
    handlePlayButtonClick(audioPlaybackStatus, messagesList, getId(message));
  };
  const renderIcon = () => {
    switch (audioPlaybackStatus) {
      case 'loading':
        return /*#__PURE__*/_jsx(VizExLoadingSpinner, {
          size: "xs",
          use: "secondary"
        });
      case 'playing':
        return /*#__PURE__*/_jsx(VizExIcon, {
          icon: /*#__PURE__*/_jsx(SVGPause, {}),
          "data-test-id": "pause-icon"
        });
      default:
        return /*#__PURE__*/_jsx(VizExIcon, {
          icon: /*#__PURE__*/_jsx(SVGPlay, {}),
          "data-test-id": "play-icon"
        });
    }
  };
  return /*#__PURE__*/_jsx(PlayMessageButtonWrapper, {
    children: /*#__PURE__*/_jsx(VizExIconButton, {
      onClick: handleButtonClick,
      use: "primary",
      size: size,
      shape: "circle",
      "aria-label": I18n.text('conversations-visitor-ui.visitorExperienceAriaLabels.playMessageAudio'),
      "data-test-id": "play-message-button",
      children: renderIcon()
    })
  });
};
PlayMessageButton.displayName = 'PlayMessageButton';
export default PlayMessageButton;